import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Stack,
    Divider,
} from "@mui/material";
import CartLoader from "../../../../../Helper/Loaders/CartLoader";
import { PrimaryTooltip } from "../../../../../Components/StyledComponent";
import CustomIcon from "../../../../../Components/CustomIcon";
import ComparisonTabs from "./ComparisonTabs";
import PrimaryTabPanel from "../../../../../Features/Tabs/PrimaryTabPanel";
import RenderComparisonTabs from "./RenderComparisonTabs";
import { toTitleCase } from "../../../../../Helper/Formatters/TextFormatter";
import { normalizeKey } from "../../../../../Helper/Common/common_helpers";
import { useTranslation } from "react-i18next";
import { getHierarchyInfo, shouldDisabledNode } from "../../../../../Helper/DigitalTwin/DigitalTwinFunctions";
import BatterySidebarContainer from "../../../components/BatterySidebarContainer";


function groupByLevel(node, result = [], maxLevel = 0) {
    const { level, children } = node;

    result[maxLevel] = {
        id: level,
        slug: level,
        name: toTitleCase(level) + 's',
        level,
        maxLevel,
    };

    if (children && Array.isArray(children)) {
        for (const child of children) {
            groupByLevel(child, result, maxLevel + 1);
        }
    }

    return result;
}

const ComparisonSideBar = ({
    batteryID,
    title,
    onChangeNode,
    onChangeTab,
    batteryConfig = {},
    batteryStructure = [],
}) => {
    const [selectedTab, setSelectedTab] = useState('');
    const [allTabs, setAllTabs] = useState([]);
    const { t } = useTranslation(['common', 'digital_twin'])

    useEffect(() => {
        let tabs = groupByLevel(batteryStructure[0]).map((tab) => ({ ...tab, disabled: shouldDisabledNode(tab.level, batteryConfig) }))
        setAllTabs(tabs)
    }, [batteryID]);

    useEffect(() => {
        if (allTabs && allTabs[0]) {
            setSelectedTab(allTabs[0].level);
        }
    }, [allTabs]);

    useEffect(() => {
        onChangeTab(selectedTab)
    }, [selectedTab]);

    if (!batteryStructure || batteryStructure.length === 0 || allTabs.length === 0) {
        return <CartLoader />
    };

    return (
        <BatterySidebarContainer title={title}>
            <ComparisonTabs tabs={allTabs} selectedTab={selectedTab} changeTheTab={(newTab) => setSelectedTab(newTab)} />

            {allTabs.map((tab, index) =>
                <PrimaryTabPanel value={selectedTab} id={tab.level} key={index} >
                    <Box sx={{ my: 2 }}>
                        <Typography variant="fw500s12c8F8F8F" sx={{ textTransform: 'capitalize' }}>Compare {tab.level}s</Typography>
                    </Box>

                    <RenderComparisonTabs
                        onChangeNode={onChangeNode}
                        data={batteryStructure}
                        maxLevel={index}
                        hierarchyLevel={tab.level}
                        batteryConfig={batteryConfig}
                    />
                </PrimaryTabPanel>
            )}
        </BatterySidebarContainer>
    );
};

export default ComparisonSideBar;
